const DECISION_TREE_CSV_STORAGE = 'DECISION_TREE_CSV_STORAGE';
const INCLUDE_CALCULATIONS = 'INCLUDE_CALCULATIONS';

export const getDecisionTreeCsvFromStorage = () : string => {
    return window.localStorage.getItem(DECISION_TREE_CSV_STORAGE) ?? '';
};

export const saveDecisionTreeCsvToStorage = (json: string) => {
    window.localStorage.setItem(DECISION_TREE_CSV_STORAGE, json);
};

export const getIncludeCalculationsFromStorage = () : boolean => {
    const shouldInclude = window.localStorage.getItem(INCLUDE_CALCULATIONS);
    return shouldInclude === 'true';
};

export const setIncludeCalculationsToStorage = (shouldInclude: boolean) => {
    window.localStorage.setItem(INCLUDE_CALCULATIONS, shouldInclude.toString());
};

